var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup31775(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.444,
    height: 11.616,
    viewBox: "0 0 89.444 11.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31775",
    "data-name": "Group 31775",
    transform: "translate(-114.54 -24.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(84 -14.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37231",
    "data-name": "Path 37231",
    d: "M133.52,689.818a2.073,2.073,0,0,0,.533-.557,2.3,2.3,0,0,0,.307-1.217,2.258,2.258,0,0,0-.785-1.8,3.46,3.46,0,0,0-2.171-.6h-3.179a1.11,1.11,0,0,0-1.114,1.114v7.977h4.167A3.823,3.823,0,0,0,133.76,694a2.683,2.683,0,0,0,.878-2.123,2.4,2.4,0,0,0-.365-1.379A2.361,2.361,0,0,0,133.52,689.818Zm-4.282-2.25h1.813a1.439,1.439,0,0,1,.861.161.777.777,0,0,1,0,1.084,1.434,1.434,0,0,1-.836.186h-1.838Zm2.877,4.953a1.627,1.627,0,0,1-.963.238h-1.914V690.9h1.889a1.638,1.638,0,0,1,.983.208.857.857,0,0,1,.275.722A.787.787,0,0,1,132.116,692.52Z",
    transform: "translate(-75.369 -646.004)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37232",
    "data-name": "Path 37232",
    d: "M220.795,693.913a1.772,1.772,0,0,1-.022-.294v-.338l-.051-1.036a3.144,3.144,0,0,0-.3-1.376,1.394,1.394,0,0,0-.5-.5,1.771,1.771,0,0,0,.641-.62,2.937,2.937,0,0,0-.388-3.447,3.288,3.288,0,0,0-2.231-.657h-3.305a1.11,1.11,0,0,0-1.114,1.114v7.977h2.2v-3.381h1.687a1.255,1.255,0,0,1,.829.208,1.9,1.9,0,0,1,.252.954l.025.928a5.272,5.272,0,0,0,.051.573,1.671,1.671,0,0,0,.172.6l.057.113h2.889l-.695-.385A.617.617,0,0,1,220.795,693.913Zm-2.3-4.715a1.356,1.356,0,0,1-.877.229h-1.889v-1.885h1.99a1.052,1.052,0,0,1,.776.254,1.09,1.09,0,0,1,0,1.4Z",
    transform: "translate(-151.729 -646.004)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37233",
    "data-name": "Path 37233",
    d: "M303.657,685.643a1.055,1.055,0,0,0-1.051.717l-2.974,8.373h2.335l.555-1.791h3.08l.58,1.791h2.335l-3.3-9.09Zm-.524,5.425.927-2.821.927,2.821Z",
    transform: "translate(-227.82 -646.004)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37234",
    "data-name": "Path 37234",
    d: "M405.523,685.643H402.7l-3.088,3.249v-3.249H398.52a1.11,1.11,0,0,0-1.114,1.114v7.977h2.2v-3.258c0-.142.04-.319.351-.423.234-.077.518.1.84.517l2.257,3.164h2.68l-3.92-5.357Z",
    transform: "translate(-314.221 -646.004)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37235",
    "data-name": "Path 37235",
    d: "M489.568,685.968a1.078,1.078,0,0,0-.325.789v7.977h6.719v-2.026H491.42V690.9h2.267a1.11,1.11,0,0,0,1.114-1.114V689H491.42v-1.456h4.541v-1.9h-5.6A1.078,1.078,0,0,0,489.568,685.968Z",
    transform: "translate(-395.375 -646.004)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37236",
    "data-name": "Path 37236",
    d: "M573.452,691.056a2.05,2.05,0,0,1-.348,1.347,1.5,1.5,0,0,1-1.137.39,1.459,1.459,0,0,1-1.126-.376,2.214,2.214,0,0,1-.334-1.361v-5.63h-1.114a1.042,1.042,0,0,0-.8.357,1.165,1.165,0,0,0-.319.807v4.668a3.36,3.36,0,0,0,.969,2.593,4.588,4.588,0,0,0,5.431.006,3.364,3.364,0,0,0,.975-2.6v-5.832h-2.2Z",
    transform: "translate(-465.217 -645.812)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37237",
    "data-name": "Path 37237",
    d: "M659.456,686.412a2.958,2.958,0,0,0-2.217-.769h-2.952a1.11,1.11,0,0,0-1.114,1.114v7.977h2.2v-3.1h1.99a2.816,2.816,0,0,0,2.121-.774,3.188,3.188,0,0,0,.734-2.206A3.049,3.049,0,0,0,659.456,686.412Zm-1.681,3a1.216,1.216,0,0,1-.864.243h-1.536v-2.087h1.636a.882.882,0,0,1,1.031,1.031A1.021,1.021,0,0,1,657.775,689.412Z",
    transform: "translate(-540.235 -646.004)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37241",
    "data-name": "Path 37241",
    d: "M394.316,585.146l-.015.011Z",
    transform: "translate(-311.477 -537.159)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37242",
    "data-name": "Path 37242",
    d: "M323.831,527.085l.011-.025Z",
    transform: "translate(-249.204 -485.83)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37243",
    "data-name": "Path 37243",
    d: "M332.7,579.022l-.017-.018Z",
    transform: "translate(-257.028 -531.731)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37246",
    "data-name": "Path 37246",
    d: "M500.992,585.146l-.015.011Z",
    transform: "translate(-405.744 -537.159)",
    fill: "#050e27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31774",
    "data-name": "Group 31774",
    transform: "translate(-154.727 -424.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74357",
    "data-name": "Path 74357",
    d: "M320.288,500.627a.322.322,0,1,1-.3.2,2.809,2.809,0,0,0,.526,3.071.315.315,0,1,1,.009.009,2.8,2.8,0,0,0,2.034.872h0a2.8,2.8,0,0,0,1.616-.511.333.333,0,1,1,.008-.005,2.807,2.807,0,0,0,1.188-2.294h0a2.811,2.811,0,0,0-4.8-1.988h0l0,0,0,0a2.816,2.816,0,0,0-.575.833A.322.322,0,0,1,320.288,500.627Zm.283,3.329,0,0,0,0Zm3.975,0,0,0,0,0Zm0-.458,0,0,0,0Zm.381-2.618a.321.321,0,1,1-.321.321A.321.321,0,0,1,324.926,500.88Zm-2.246-1.719a.322.322,0,1,1-.322.322A.322.322,0,0,1,322.68,499.161Zm-1.652,1.276a2.166,2.166,0,0,1,3.7,1.531h0a2.159,2.159,0,0,1-.634,1.531h0a2.166,2.166,0,0,1-3.063-3.063Zm-.455,0h0Z",
    transform: "translate(-47.484 -47.484)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3270",
    "data-name": "Ellipse 3270",
    cx: 1.437,
    cy: 1.437,
    r: 1.437,
    transform: "translate(273.525 453.172) rotate(-4.731)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74358",
    "data-name": "Path 74358",
    d: "M272.336,459.605a5.807,5.807,0,1,0-2.38-7.86A5.807,5.807,0,0,0,272.336,459.605Zm.029-7.551-.063.29-2.809,1.021.063-.29Zm4.225-.74-1.491-2.59.3.012,1.166,2.026.329.556h-.186Zm1.89,4.588-.04-.294,2.294-1.916.039.294Zm-5.035,1.63a3.456,3.456,0,1,1,4.678-1.417A3.456,3.456,0,0,1,273.445,457.532Zm3.953,2.156-2.5-1.552.264-.131,2.5,1.552Zm-5.954-.818.183-2.983.241.173-.184,2.983Z",
    transform: "translate(0 0)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74359",
    "data-name": "Path 74359",
    d: "M430.912,449.368a5.8,5.8,0,0,0-5.342-.072c-.058.029-.115.059-.172.09l-.133.075a7.388,7.388,0,0,1,1.717,1.778l.093-.032.081-.026.082-.024.068-.018c.088-.023.176-.043.267-.059l.085-.014q.075-.012.151-.02l.052-.005.061-.005.084,0,.088,0h.088a3.456,3.456,0,0,1,1.943,6.315l-.007,0-.087.057c-.027.018-.055.034-.082.05s-.031.019-.047.028l-.06.034-.059.031a3.452,3.452,0,0,1-2.809.185,6.1,6.1,0,0,1-1.715,1.77l.033.02c.08.046.162.091.245.133l.005,0c.082.042.166.082.25.121.171.077.347.147.526.207h0c.09.03.18.058.271.084a5.654,5.654,0,0,0,.562.129c.047.009.1.017.143.024s.1.014.145.02c.1.012.195.023.293.03l.148.009.164.006.134,0a5.806,5.806,0,0,0,1.863-.305c.072-.024.142-.05.213-.077l.105-.042c.058-.024.116-.048.173-.074l.064-.029c.059-.027.117-.055.174-.083l.1-.05.076-.04.082-.046.078-.045.012-.008.077-.046a5.807,5.807,0,0,0-.286-10.077Zm-.933,1.953H429.8l-.115,0-1.491-2.59.3.012,1.166,2.026.329.556Zm.516,8.37-2.5-1.552.264-.131,2.5,1.552Zm1.082-3.786-.039-.294,2.294-1.916.04.294Z",
    transform: "translate(-146.731 -0.003)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74360",
    "data-name": "Path 74360",
    d: "M461.223,504.323a.322.322,0,0,1-.183-.587,2.171,2.171,0,0,1-1.882.306,5.877,5.877,0,0,1-.254.6,2.8,2.8,0,0,0,2.5-.37A.321.321,0,0,1,461.223,504.323Zm1.153-3.448a2.814,2.814,0,0,0-3.47-1.576,5.931,5.931,0,0,1,.253.6,2.167,2.167,0,0,1,1.884,3.838.322.322,0,0,1,.366.53,2.814,2.814,0,0,0,.967-3.389Zm-2.469-1.07a.321.321,0,1,1,.321-.321A.322.322,0,0,1,459.907,499.8Zm2.246,1.718a.321.321,0,1,1,.321-.321A.321.321,0,0,1,462.153,501.523Z",
    transform: "translate(-178.377 -47.484)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74361",
    "data-name": "Path 74361",
    d: "M468.537,523.738a1.438,1.438,0,0,1-1.858,1.375,6.132,6.132,0,0,0,0-2.749,1.438,1.438,0,0,1,1.856,1.375Z",
    transform: "translate(-185.691 -69.253)",
    fill: "#050e27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31775);
export default __webpack_public_path__ + "static/media/Group 31775.e7d0fed033be1117cd2b34ac7509eb61.svg";
export { ForwardRef as ReactComponent };